import initProductVariants from './product-variants';
import initQuantityInputs from './quantityInputs';
import initAtcForm from './atcForm';
import { setPopupClose } from '../utils/popupController';
import { SELECTORS } from '../utils/constants';
import getLocalePrefix from '../lib/getLocalePrefix';
import { initSwiper } from './swiper';

const initAtcPopup = () => {
  const atcButtons = document.querySelectorAll('[data-product-card-atc]:not([data-quick-add-trigger])');
  if (!atcButtons) return;
  const popup = document.querySelector('[data-atc-popup]');
  const popupContent = popup.querySelector('[data-atc-popup-content]');
  const popupCloseBtn = popup.querySelector('[data-atc-popup-close]');

  const getProductData = async (atcBtn) => {
    const loadingSpinner = atcBtn.querySelector(SELECTORS.LOADING_SPINNER);
    loadingSpinner.classList.remove('hidden');
    const localePrefix = getLocalePrefix();
    try {
      const product = await fetch(`${location.origin}${localePrefix}/products/${atcBtn.dataset.productCardAtc}?view=atc-popup`);
      await loadingSpinner.classList.add('hidden');
      return product;
    } catch (e) {
      console.info(e);
      return [];
    }
  };

  const renderPopup = async (atcBtn) => {
    const productResponse = await getProductData(atcBtn);
    const htmlText = await productResponse.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    const productPopupHTML = doc.querySelector('[data-atc-popup-product]');
    popupContent.innerHTML = productPopupHTML.innerHTML;
    requestAnimationFrame(() => {
      initProductVariants(popup);
      initQuantityInputs(popup);
      initSwiper();
      if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }
    });
  };

  const closePopup = () => {
    popup.close();
    popupContent.innerHTML = '';
    popupCloseBtn.removeEventListener('click', closePopup);
  };
  setPopupClose(closePopup);

  const openPopup = async (atcBtn, isQuickOrder) => {
    await renderPopup(atcBtn);
    await popup.showModal();
    initAtcForm(true, isQuickOrder);
    popupCloseBtn.addEventListener('click', closePopup);
  };

  atcButtons.forEach(atcBtn => {
    atcBtn.addEventListener('click', () => {
      openPopup(atcBtn, atcBtn.hasAttribute('data-atc-quick-order'));
    });
  });
};

export default initAtcPopup;
